<template>    
    <BaseModal :id="'static'" :title="title">
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                />
                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormDynamic     from '@/components/FormDynamic.vue'
import Breadcrumb      from '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal       from '@/components/BaseModal'
import CentralButtons  from '@/components/CentralButtons'
import FormResources    from  './FormResources'

export default {

    name:   'FormModal',
    props: [
        'title',
        'breadcrumb',
        'parent_id',
        'rest_api',
        'array_options',
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_data: {
                parent_id:      this.parent_id,
                title:          '',
                content:        '',
                creation_date:  '',
            },
            form_backup: {
                parent_id:      this.parent_id,
                title:          '',
                content:        '',
                creation_date:  '',
            },
            form_format:    FormResources.note_form_format,
        }
    },

    methods:{

    },
    
}
</script>